<app-side-nav-outer-toolbar title="ihunter">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</app-side-nav-outer-toolbar>